<script lang="ts">
  import { DateTime } from 'luxon'
  import BarChart from './BarChart.svelte'
  import DeleteDayButton from './DeleteDayButton.svelte'
  import { grid_results } from './Results'
  import { authed_user } from '../Users/observables'
  import { Modal as UnTypedModal } from 'svelte-simple-modal'
  import { SvelteComponentTyped } from 'svelte'
  const Modal = UnTypedModal as unknown as new (...args: any) => SvelteComponentTyped

  function compareDates(dateA: string, dateB: string) {
    let date1 = DateTime.fromISO(dateA)
    let date2 = DateTime.fromISO(dateB)

    let diff = date1.diff(date2, ['years', 'months', 'days', 'hours'])
    return diff
  }

  function columnSizeRatio(index: number) {
    const startEndGap = compareDates(
      $grid_results?.dates[$grid_results?.dates.length - 1],
      $grid_results?.dates[0],
    )

    const currGap = compareDates($grid_results?.dates[index], $grid_results?.dates[0])

    const ratio = 1 + Math.round((currGap.toMillis() / startEndGap.toMillis()) * 100)

    return ratio
  }

  function showDate(index: number) {
    const current = DateTime.fromISO($grid_results?.dates[index])
    const previous = DateTime.fromISO($grid_results?.dates[index === 0 ? 0 : index - 1])

    if (current.year !== previous.year) {
      return current.toFormat('yyyy')
    }
    if ($grid_results?.dates.length - index > 12 && index % 4 !== 0) {
      return ''
    }
    if (current.month !== previous.month) {
      return current.toFormat('MMM')
    }
    if (current.day !== previous.day) {
      return current.toFormat('DD')
    }
    return ''
  }
</script>

<Modal>
  {#if !$grid_results}
    <p>Loading...</p>
  {:else}
    <div
      class="grid"
      style="grid-template-columns: 7em {$grid_results.dates
        .slice(0, -1)
        .map((d, i) => `${columnSizeRatio(i)}fr`)
        .join(' ')} 7em;"
    >
      {#each $grid_results.dates as date, i}
        <div class="date-container" style="grid-row: 1 / span 1; grid-column: {i + 2} / span 1;">
          <p class={'rotated'}>
            {showDate(i)}
          </p>
          {#if $authed_user?.role === 'Admin'}
            <DeleteDayButton {date} />
          {/if}
        </div>
      {/each}
      <p style="grid-row: 2 / span 1; grid-column: 1 / span 1;">Total</p>
      {#each $grid_results.totals as total, i}
        <BarChart
          result={total}
          row={2}
          column={total.date_index + 2}
          i={total.date_index + 1 === $grid_results.totals.length ? '0.2em' : '0em'}
        />
      {/each}
      {#each $grid_results.cardResults as card, i}
        <p style="grid-row: {i + 3} / span 1; grid-column: 1 / span 1;">
          {card.heading}
        </p>
        {#each card.results as result}
          <BarChart
            {result}
            row={i + 3}
            column={result.date_index + 2}
            i={result.date_index + 1 === $grid_results.dates.length ? '0.2em' : '0em'}
          />
        {/each}
      {/each}
    </div>
  {/if}
</Modal>

<style>
  .date-container {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    justify-items: center;
    position: relative;
    min-height: 4rem;
    min-width: 0.75rem;
  }
  .date-container p {
    position: absolute;
  }
  .grid {
    display: grid;
    row-gap: 0.2em;
    /* overflow: auto; */
    max-width: 100%;
    width: 100%;
    /* transform-scale: 1; */
  }
  .rotated {
    transform: rotate(80deg);
  }
</style>
